import { Account, AccountIntegrationConfigMappingType, getAccountCRMIntegrationConfig } from '../../../models/Account'
import { DEFAULT_ACCOUNT_INTEGRATION_CONFIG_MAPPINGS, IntegrationServiceId } from '../../../common/integrations'

export const getAccountIntegrationConfigMappings = (account: Account, serviceId: IntegrationServiceId) => {
  const accountIntegrationConfig = getAccountCRMIntegrationConfig(account, serviceId)
  if (!accountIntegrationConfig) {
    return DEFAULT_ACCOUNT_INTEGRATION_CONFIG_MAPPINGS
  }

  const contactMapping = accountIntegrationConfig.mappings[AccountIntegrationConfigMappingType.CONTACT]
  const contactObjectName = typeof contactMapping === 'string' ? contactMapping : (contactMapping?.objectName ?? 'contact')

  return {
    [AccountIntegrationConfigMappingType.CONTACT]: contactObjectName,
  }
}
